import type { ThemeComponentType } from '../types';

export const NativeSelect: ThemeComponentType = {
  defaultProps: {
    p: 'lg',
    shadow: 'xs',
  },
  styles: (_theme, _variant) => ({
    input: {
      paddingTop: 0,
      paddingBottom: 0,

      '&&:read-only': {
        cursor: 'default',
        background: 'white',
      },
    },
  }),
};
